export const DATA_COLLECTION_ITEMS_IN_CASE_OPTIONS = [
  "1 (1x1)",
  "2 (2x1)",
  "3 (3x1)",
  "4 (2x2)",
  "4 (4x1)",
  "5 (5x1)",
  "6 (6x1)",
  "6 (3x2)",
  "7 (7x1)",
  "8 (4x2)",
  "8 (8x1)",
  "9 (9x1)",
  "10 (5x2)",
  "10 (10x1)",
  "12 (4x3)",
  "12 (6x2)",
  "12 (12x1)",
  "15 (5x3)",
  "15 (15x1)",
  "18 (6x3)",
  "18 (9x2)",
  "18 (18x1)",
  "20 (5x4)",
  "20 (10x2)",
  "24 (6x4)",
  "24 (8x3)",
  "24 (12x2)",
  "24 (24x1)",
  "30 (5x6)",
  "30 (6x5)",
  "30 (10x3)",
  "36 (6x6)",
  "36 (9x4)",
  "36 (12x3)",
  "40 (8x5)",
  "40 (10x4)",
  "48 (8x6)",
  "48 (12x4)",
  "48 (16x3)"
];

export const DATA_COLLECTION_PRIMARY_PACKAGE_MATERIAL_OPTIONS = [
  'PET',
  'rPET',
  'Tetra',
  'Aluminum',
  'Carton',
  'Copolymer',
  'Glass',
  'HDPE',
  'Multilayer',
  'PP',
  'Bag',
];

export const DISTRIBUTION_PRIMARY_PACKAGE_TYPE_OPTIONS = [
  { label: 'PET Bottles', value: 'pet_bottles' },
  { label: 'Cans', value: 'cans' },
  { label: 'Carton', value: 'Carton' },
  { label: 'Glass', value: 'Glass' },
  { label: 'Multilayer', value: 'Multilayer' },
  { label: 'Bag', value: 'Bag' },
  { label: 'rPET', value: 'rPET' },
];

export const DISTRIBUTION_ITEMS_PER_CASE_OPTIONS = DATA_COLLECTION_ITEMS_IN_CASE_OPTIONS.map((value, id) => ({
  id,
  value: value.replace(/x/g, '×'),
}));

export function getDistributionPackageMaterial(primaryPackageType: unknown): string {
  if (primaryPackageType === 'pet_bottles') return 'PET';
  if (primaryPackageType === 'cans') return 'Aluminum';
  return String(primaryPackageType || '');
}

export const TERTIARY_PACKAGE_TYPE_OPTIONS = [
  'Shrink Bundle',
  'Corrugated Case',
  'Paperboard',
  'Tray -Shrink',
  'Tray',
  'Corrugated',
  'Others',
];
export const BRAND_OPTION_NEW = [
   '100% Gold',
   '7UP',
   'Adrenaline',
   'Agusha',
   'Alvalle',
   'AMP',
   'Aqua Minerale',
   'Aquafina',
   'Bario',
   'Be-Light',
   'Bio Max',
   'Bilz',
   'Bilz Pap',
   'Brisk',
   'Bubly',
   'Calebs',
   'CSD',
   'CSD/Water',
   'chudo',
   'Chudo Yagoda',
   'Concordia',
   'Copella',
   'CytoSport',
   'D&G',
   'Dole',
   'Domik v Derevne',
   'Dr Pepper',
   'Drinkfinity',
   'Drips by Pepsi',
   'Drive Me',
   "Duke's",
   'Essentuki',
   'Evervess',
   'Evolve',
   'Fast Twitch',
   'Fiesta',
   'Frugurt',
   'Fruit Shoot',
   'Fruko',
   'Fruktovy Sad',
   'Frutly',
   'Frutz',
   'Gatorade',
   'Greip',
   'H2OH',
   'Imunele',
   'Irn Bru',
   'Ivi',
   'Izze',
   'J7',
   'Kas',
   'Kasfruit',
   'Kem',
   'Kero Coco',
   'KeVita',
   'KRYSTALICZNE ZRODLO',
   'KUBANSKAYA BURENKA',
   'Lamber',
   'Lavazza',
   'Lehar',
   'Lemon Lemon',
   'LifeWTR',
   'Lipton',
   'Looza',
   'Lubimiy',
   'Magico',
   'Majutel',
   'Manzanita Sol',
   'Mirinda',
   'Mist Twst',
   'Mtn Dew',
   'Muscle Milk',
   'Naked',
   'Nobis',
   'Not Brand Specific',
   'O.N.E.',
   'Ocean Spray',
   'Ole',
   'Opolie',
   'Paso de los Toros',
   'Pigat',
   'Pepsi',
   'Pop Works and Company',
   'Poppi',
   'Prigat',
   'Privet',
   'Propel',
   'PureLeaf',
   'Punica',
   'Quaker',
   'Radical',
   'RedRock',
   'Rica',
   'Rockstar',
   'Rodniki Rossii',
   'Roua Muntilor',
   'Rojita',
   'Roua',
   'Russky Dar',
   'Sadochok',
   'San Carlos',
   'Sandora',
   'Sandorik',
   'Sangria Casera',
   'Schweppes',
   'Schwip Schwap',
   'Shani',
   'Slice',
   'Slovyanochka',
   'SoBe',
   'SodaStream',
   'Sol',
   'Split',
   'Starbucks',
   'Sting',
   'Stubborn',
   'Tazo',
   'Tea Kitchen',
   'TEEM',
   'Ting',
   'Toddy',
   'Toddynho',
   'Toma',
   'Triple Kola',
   'Tropicana',
   'Unmuddled',
   'Veselyi Molochnik',
   'Ya',
   'Yedigun',
   'Zucoa',
 ];